module.exports = __webpack_public_path__ + "static/media/plus-dark.10445285.svg";